import { useState } from 'react'
import './recovery-otp.css'
import {
  RECOVERY_OTP_CONFIG_BUTTON,
  RECOVERY_OTP_CONFIG_MESSAGE,
  RECOVERY_OTP_CONFIG_TITLE,
} from '../../constants/ui.labels'
import ContentHeader from '../ContentHeader'
import RecoveryOTPBox from '../RecoveryOTPBox'
import RecoveryOTPConfirm from '../RecoveryOTPConfirm'
import Button from '@talkdesk/cobalt-react-button'
import Flex from '@talkdesk/cobalt-react-flex'
import Box from '@talkdesk/cobalt-react-box'

const RecoveryOTPConfiguration = ({
  onConfirm,
  confirmText = RECOVERY_OTP_CONFIG_BUTTON,
  requiresConfirm = true,
  fileTitle,
  fileName,
  ...props
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handlesClick = () =>
    requiresConfirm ? setShowConfirmation(true) : onConfirm()

  return (
    <Flex direction='column' alignX='center' alignY='center' padding='4'>
      <ContentHeader
        title={RECOVERY_OTP_CONFIG_TITLE}
        message={RECOVERY_OTP_CONFIG_MESSAGE}
      />
      {showConfirmation && (
        <RecoveryOTPConfirm
          onDismiss={() => setShowConfirmation(false)}
          onConfirm={onConfirm}
          fileTitle={fileTitle}
          fileName={fileName}
        />
      )}
      <RecoveryOTPBox fileTitle={fileTitle} fileName={fileName} {...props} />
      <Box width='100%' paddingTop='4'>
        <Button htmlType='button' shape='full-width' onClick={handlesClick}>
          {confirmText}
        </Button>
      </Box>
    </Flex>
  )
}

export default RecoveryOTPConfiguration
